import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import styles from "./PromotionalResources.module.scss";
import FilterSidebar from "../../../common/AffiliateCommonComponents/FilterSidebar/FilterSidebar";
import BannersDisplayAds from "./BannersDisplayAds/BannersDisplayAds";
import SocialMediaPosts from "./SocialMediaPosts/SocialMediaPosts";
import ProductsImages from "./ProductsImages/ProductsImages";
import ProductVideos from "./ProductVideos/ProductVideos";

const categoriesData = [
    { key: "1", label: "Banners and Display ads" },
    { key: "2", label: "Social Media Posts" },
    { key: "3", label: "Products Images" },
    { key: "4", label: "Product Videos" },
    { key: "5", label: "Email templates" },
];

const PromotionalResources = () => {
    const [activeCategory, setActiveCategory] = useState(categoriesData[0]?.key || "");

    return (
        <Container fluid className={styles.promotionalResourcesContainer}>
            <Row className="g-0">
                <Col xl="3" className="pe-xl-3 pb-4 pb-xl-0">
                    <FilterSidebar tabs={categoriesData} activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
                </Col>

                <Col xl="9" className="ps-2 ps-xl-3">
                    {activeCategory === "1" && <BannersDisplayAds />}
                    {activeCategory === "2" && <SocialMediaPosts />}
                    {activeCategory === "3" && <ProductsImages />}
                    {activeCategory === "4" && <ProductVideos />}
                </Col>
            </Row>
        </Container>
    );
};

export default PromotionalResources;